import { createTheme, colors } from "@mui/material";
import shadows from "./shadows";
import typography from "./typography";
import cssVariables from "./cssVariables";

import red from "@mui/material/colors/red";
import { blue } from "@mui/material/colors";

const param = {
  base: {
    "borderRadius": "5px",
  },
};

const default_theme = createTheme({
  palette: {
    background: {
      default: "#FAFAFA",
      paper: colors.common.white,
    },
    primary: {
      contrastText: "#ffffff",
      main: "#5DA196",
    },
    warning: {
      contrastText: "#ffffff",
      main: "#EFB76D",
    },
    information: {
      contrastText: "#ffffff",
      main: "#5DA196",
    },
    emphasize: {
      contrastText: "#ffffff",
      main: "#6694CC",
    },
    button_primary: {
      contrastText: "#ffffff",
      main: "#5DA196",
    },
    trimary: {
      contrastText: "#ffffff",
      main: "#ff0029",
    },
    text: {
      primary: "#404349",
      secondary: "#6b778c",
    },
    black: {
      main: cssVariables.color.black,
    },
    white: {
      contrastText: cssVariables.color.black,
      main: cssVariables.color.white,
    },
    red: {
      contrastText: "#ffffff",
      main: cssVariables.color.red,
    },
    blue: {
      contrastText: "#ffffff",
      main: cssVariables.color.blue,
    }
  },
  components: {
    MuiTableCell: {
      styleOverrides: {
        // Name of the slot
        // root: {
        //   // Some CSS
        //   fontSize: "1rem",
        //   "border-width": 0,
        // },
      },
      variants: [
        {
          props: { variant: "no-border" },
          style: {
            "border-width": 0,
            "padding-left": 0,
          },
        },
      ],
    },
    MuiButton: {
      variants: [
        {
          props: { variant: "contained" },
          style: {
            textTransform: "none",
            paddingTop: "8px",
            paddingBottom: "8px",
            paddingLeft: "20px",
            paddingRight: "20px",
          },
        },
        {
          props: { variant: "outlined" },
          style: {
            textTransform: "none",
            borderColor: "#DADADA",
            paddingTop: "7px",
            paddingBottom: "7px",
            paddingLeft: "20px",
            paddingRight: "20px",
          },
        },
        {
          props: { variant: "dashed" },
          style: {
            textTransform: "none",
            border: `2px dashed grey${blue[500]}`,
          },
        },
        {
          props: { variant: "dashed", color: "secondary" },
          style: {
            border: `4px dashed ${red[500]}`,
          },
        },
        {
          props: { variant: "dashed-solid" },
          style: {
            border: "1px solid #DADADA",
          },
        },
        {
          props: { variant: "toolbar" },
          style: {
            color: "white",
            margin: "5px",
            border: "1px solid white",
          },
        },
        {
          props: { variant: "toolbar-black" },
          style: {
            color: "black",
            "padding-bottom": "10px",
            "padding-left": "40px",
            "padding-right": "40px",
            "padding-top": "10px",
            border: "1px solid black",
          },
        },
        {
          props: { variant: "contained-black" },
          style: {
            color: "white",
            background: "#404349",
            "padding-bottom": "10px",
            "padding-left": "40px",
            "padding-right": "40px",
            "padding-top": "10px",
            "&:hover": {
              color: 'white',
              background: "#404349",
            }
          },
        },
        {
          props: { variant: "dashed-solid-primary" },
          style: {
            border: "1px solid #5DA196",
          },
        },
      ],
    },
    MuiCardHeader: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          fontSize: "1rem",
          "border-width": 0,
          "borderRadius": param.base["border-radius"],
        },
      },
      variants: [
        {
          props: { variant: "summary" },
          style: {
            padding: "20px 32px",
            background: "#404349",
            color: "white",
            textAlign: "left"
          },
        },
        {
          props: { variant: "header_carryscore" },
          style: {
            padding: "5px",
            background: "#6B6B6B",
            color: "white",
          },
        },
        {
          props: { variant: "header_use_carryscore" },
          style: {
            padding: "5px",
            background: "#5DA196",
            color: "white",

          },
        },
      ],
    },
    MuiToolbar: {
      styleOverrides: {
        // Name of the slot
        root: {
          // Some CSS
          "borderRadius": param.base["border-radius"],
        },
      },
      variants: [
        {
          props: { variant: "summary" },
          style: {
            padding: "20px",
            background: "black",
            color: "white",
          },
        },
      ],
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "14px"
        }
      }
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          background: "#fff",
        },
      },
    },
    MuiStepIcon: {
      styleOverrides: {
        root: {
          color: "#F0F0F0",
        },
      },
    },
    MuiTableSortLabel: {
      styleOverrides: {
        icon: {
          opacity: 0.4,
        },
      },
    },
  },
  shadows,
  typography,
});
export default default_theme;
